import { useEffect, useState } from 'react';
import { api, incluyePruebas, setIncluyePruebas } from '../lib/api';
import { useAuth } from '../auth/AuthContext';

/**
 * "Sin N cuentas de prueba · incluir" junto al selector de periodo de cada pantalla de métricas. Las cuentas de
 * prueba (hub_015, se marcan en la Ficha) no cuentan en ningún número; esto lo dice y deja verlas. Sólo sale
 * para admin y si hay alguna. La lista se pide una vez por visita.
 */
let cache: Promise<number | null> | null = null;
const cuantas = () => (cache ||= api<{ cuentas: unknown[] }>('pruebas').then((r) => r.cuentas.length).catch(() => null));

export function PruebasChip() {
  // Las cuentas de prueba son de admin (piden PIN): a las demás cuentas ni se les pregunta (el API contestaría 403).
  const { user } = useAuth();
  const esAdmin = user?.role === 'admin';
  const [n, setN] = useState<number | null>(null);
  useEffect(() => { if (!esAdmin) return; let vivo = true; cuantas().then((x) => { if (vivo) setN(x); }); return () => { vivo = false; }; }, [esAdmin]);
  if (!n) return null;
  const con = incluyePruebas();
  return (
    <button type="button" className="btn-ghost" data-pruebas-chip={con ? 'con' : 'sin'}
      title={con ? 'Los números incluyen las cuentas de prueba. Toca para quitarlas.' : 'Las cuentas de prueba no cuentan en ningún número. Toca para verlas también.'}
      onClick={() => { setIncluyePruebas(!con); window.location.reload(); }}
      style={{ padding: '5px 11px', fontSize: 12.5, borderStyle: 'dashed', color: con ? 'var(--warning, #92400e)' : 'var(--ink-soft)', background: con ? '#fef3c7' : undefined }}>
      {con ? `Con ${n} cuenta${n === 1 ? '' : 's'} de prueba · quitar` : `Sin ${n} cuenta${n === 1 ? '' : 's'} de prueba · incluir`}
    </button>
  );
}
